export default {
    get: function (id) {
        return window.axios.get(`emailTemplates/${id}`);
    },
    update: function (id, data) {
        return window.axios.put(`emailTemplates/${id}`, data);
    },
}